import { render, staticRenderFns } from "./RecentAdditions.vue?vue&type=template&id=bd81a7e8"
import script from "./RecentAdditions.vue?vue&type=script&lang=ts"
export * from "./RecentAdditions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports